import 'Styles/templates/article.scss';

import LazyVideo from '../components/lazy-video';
import BlogGrid from '../vue/blog/blog-grid';
import TopStories from '../vue/blog/top-stories';
import Hotspot from '../components/hotspot';
import ProductSlider from '../vue/product-slider/index';
import ArticleCommon from '../components/article-common';
import GalleryModal from '../vue/gallery-modal/index'

LazyVideo();
BlogGrid();
TopStories();
Hotspot();
ProductSlider();
ArticleCommon();
GalleryModal();